import { NgModule } from '@angular/core';
import { NkMainComponent } from './main.component';

@NgModule({
  imports: [
    NkMainComponent
  ],
  exports: [NkMainComponent],
})
export class NkMainModule {}
